export enum Division {
  ACM = 'ACM',
  ADMINISTRATOR = 'Administrator',
  CABIN_CREW = 'Inflight',
  CCM = 'CCM',
  COMM = 'COMM',
  COPILOT = 'COPILOT',
  DEADHEAD = 'DEADHEAD',
  DISPATCHER = 'OCC',
  GH = 'GH',
  GROUND_HANDLER = 'Airport Ops',
  GUEST = 'GUEST',
  MAINTENANCE_CREW = 'Tech Ops',
  PILOT = 'Flight Ops',
  SCCM = 'SCCM',
  UNKNOWN = 'Unknown',
}
